import { observable, action, computed, toJS, makeAutoObservable } from 'mobx';
import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';

export class SelectMultipleState {
    @observable isFocus: boolean = false;
    @observable isError: boolean = false;
    @observable isEmpty: boolean = false;
    @observable areOptionsVisible: boolean = false;

    private readonly maxSelections: number = 1;
    private readonly inputState: FormInputState<Array<string>, Array<string>>;

    constructor(inputState: FormInputState<Array<string>, Array<string>>, maxSelections: number) {
        this.inputState = inputState;
        this.maxSelections = maxSelections;
        makeAutoObservable(this);
    }

    @action hideOptions = (): void => {
        this.areOptionsVisible = false;
    };

    @action toggleOptionsVisibility = (): void => {
        this.areOptionsVisible = !this.areOptionsVisible;
    };

    @action handleFocus = (): void => {
        this.isFocus = true;
        this.isError = false;
    };

    @action handleBlur = (): void => {
        this.isFocus = false;
        this.inputState.setAsVisited();
    };

    @action handleChange = (): void => {
        this.inputState.setAsVisited();
    };

    @action checkIsEmptyInput = (): void => {
        this.isEmpty = this.inputState.value.length === 0;
    };

    @action addValue = (targetValue: string): void => {
        const selectedValues = this.value;
        const index = selectedValues.indexOf(targetValue);
        if (index === -1) {
            if (selectedValues.length < this.maxSelections) {
                selectedValues.push(targetValue);
            }
        }
        this.inputState.setValue(selectedValues);
        this.inputState.setAsVisited();
        this.checkIsEmptyInput();
    };

    @action removeValue = (targetValue: string): void => {
        const selectedValues = this.value;
        const index = selectedValues.indexOf(targetValue);
        if (index !== -1) {
            selectedValues.splice(index, 1);
        }
        this.inputState.setValue(selectedValues);
        this.inputState.setAsVisited();
        this.checkIsEmptyInput();
    };

    @computed get value(): string[] {
        return toJS(this.inputState.value);
    }
}
